import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['dropdown', 'button'];

  connect() {
    this.boundHandleOutsideClick = this.handleOutsideClick.bind(this);

    document.addEventListener('click', this.boundHandleOutsideClick, true);
    this.syncFromDOM();
  }

  disconnect() {
    document.removeEventListener('click', this.boundHandleOutsideClick, true);
  }

  toggle() {
    this.dropdownTarget.classList.toggle('hidden');
    this.dropdownTarget.classList.toggle('opacity-0');
    this.dropdownTarget.classList.toggle('scale-95');
  }

  selectOption(event) {
    const selectedValue = event.target.dataset.value || this.buttonTarget.dataset.placeholder;
    this.buttonTarget.innerText = selectedValue;

    if (selectedValue === this.buttonTarget.dataset.placeholder) {
      this.buttonTarget.classList.remove('text-black-1000');
      this.buttonTarget.classList.add('text-black-400');
    } else {
      this.buttonTarget.classList.remove('text-black-400');
      this.buttonTarget.classList.add('text-black-1000');
    }

    this.close();
    this.submitForm();
  }

  syncFromDOM() {
    const checked = this.element.querySelector('input[type=radio]:checked');
    const value = checked?.dataset.value || this.buttonTarget.dataset.placeholder;
    this.buttonTarget.innerText = value;

    if (value === this.buttonTarget.dataset.placeholder) {
      this.buttonTarget.classList.remove('text-black-1000');
      this.buttonTarget.classList.add('text-black-400');
    } else {
      this.buttonTarget.classList.remove('text-black-400');
      this.buttonTarget.classList.add('text-black-1000');
    }
  }

  submitForm() {
    const form = this.element.closest('form');
    if (form) {
      form.requestSubmit();
    }
  }

  close() {
    this.dropdownTarget.classList.add('hidden', 'opacity-0', 'scale-95');
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.close();
    }
  }

  clearSelection() {
    const radios = this.element.querySelectorAll('input[type=radio]');
    radios.forEach((radio) => (radio.checked = false));

    this.buttonTarget.innerText = this.buttonTarget.dataset.placeholder;
    this.buttonTarget.classList.remove('text-black-1000');
    this.buttonTarget.classList.add('text-black-400');

    this.close();
    this.submitForm();
  }
}
